import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
    const token = ref<string | null>(localStorage.getItem('sf_token') || sessionStorage.getItem('sf_token'))
    const user = ref<any | null>(null)

    // Try to rehydrate user from storage if basic info is stored
    const savedUser = localStorage.getItem('sf_user') || sessionStorage.getItem('sf_user')
    if (savedUser) {
        try {
            user.value = JSON.parse(savedUser)
        } catch (e) {
            console.error('Failed to parse user from storage')
        }
    }

    const isLoggedIn = () => !!token.value

    function setSession(newToken: string, newUser: any, remember: boolean = true) {
        token.value = newToken
        user.value = newUser

        // Clear both first to avoid duplicates
        localStorage.removeItem('sf_token')
        localStorage.removeItem('sf_user')
        sessionStorage.removeItem('sf_token')
        sessionStorage.removeItem('sf_user')

        if (remember) {
            localStorage.setItem('sf_token', newToken)
            localStorage.setItem('sf_user', JSON.stringify(newUser))
        } else {
            sessionStorage.setItem('sf_token', newToken)
            sessionStorage.setItem('sf_user', JSON.stringify(newUser))
        }
    }

    function logout() {
        token.value = null
        user.value = null
        localStorage.removeItem('sf_token')
        localStorage.removeItem('sf_user')
        sessionStorage.removeItem('sf_token')
        sessionStorage.removeItem('sf_user')
    }

    return {
        token,
        user,
        isLoggedIn,
        setSession,
        logout
    }
})
